<template>
  <div class="sidenav-container">
    <div v-if="toggleSidebar" class="backdrop" @click="$store.dispatch('toggleSidebar')"></div>

    <transition name="slide-side">
      <div v-if="toggleSidebar" class="sidenav">
        <HeaderNav />
        <MenuSide />
      </div>
    </transition>
  </div>
</template>

<script>
import HeaderNav from "@/components/HeaderNav.vue"
import MenuSide from "@/components/MenuSide.vue"
export default {
  name: "TheSideNav",
  components: {
    HeaderNav,
    MenuSide,
  },
  computed: {
    toggleSidebar() {
      return this.$store.getters["toggleSidebar"]
    },
  },
}
</script>

<style scoped>
.sidenav-container {
  height: 100%;
  width: 100%;
}
.sidenav {
  height: 100%;
  width: 300px;
  background-color: #424242;
  z-index: 10000;
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  padding: 30px;
}
.backdrop {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
}
.slide-side-enter-active,
.slide-side-leave-active {
  transition: all 0.3s ease-out;
}
.slide-side-enter,
.slide-side-leave-to {
  transform: translateX(-100%);
}
.sidenav-container >>> .sidenav {
  z-index: 2000;
}
</style>
